import { FundingSource, FundingSourceAccessLevel } from "admin/types/interfaces/funding";
import { SWRConfiguration } from "swr";
import { useV1List } from "~/hooks/useV1List";
import { ACCESS_CONTROLLER_V1 } from "~/utils/accessController";

// With minAccess, lists only sources where the user's highest access level is at least that one.
const useFundingSources = (
  enabled: boolean,
  minAccess?: FundingSourceAccessLevel,
  options?: SWRConfiguration
) => {
  const baseUrl = `${ACCESS_CONTROLLER_V1}/funding-sources`;
  const url = enabled ? (minAccess ? `${baseUrl}?min_access=${minAccess}` : baseUrl) : null;
  return useV1List<FundingSource>(url, { shouldCamelize: true, ...options });
};

export default useFundingSources;
